import React, { Component } from 'react'
import styled from 'styled-components/macro'
import { Text, Graphic, Button, Spacing } from '../../../components/ui'

const width = window.innerWidth

const HeaderWrapper = styled.div`
  position: absolute;
  top: -80px;
`
const SkipWrapper = styled.div`
  position: absolute;
  top: 50px;
  right: 80px;
  width: 130px;
`

const HeadingWrapper = styled.div`
  position: absolute;
  top: 80px;
`
const GraphicWrapper = styled.div`
  position: absolute;
  top: 180px;
`
const TextHeaderWrapper = styled.div`
  position: absolute;
  width: 550px;
  top: 460px;
`
const TextWrapper = styled.div`
  position: absolute;
  width: 550px;
  top: 550px;
`
const ButtonWrapper = styled.div`
  position: absolute;
  width: 440px;
  top: 690px;
`

export class Onboarding4 extends Component {
  state = {
    login: true, // switch between Login and SignUp
    email: '',
    password: '',
    name: '',
  }

  render() {
    const { history } = this.props
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <HeaderWrapper>
          <Graphic name="Header" width={width} />
        </HeaderWrapper>
        <SkipWrapper>
          <Button
            block
            style={{
              borderWidth: 0,
              backgroundColor: 'rgba(225, 225, 225, 0.2)',
              fontWeight: 'bold',
            }}
          >
            Skip
          </Button>
        </SkipWrapper>
        <HeadingWrapper>
          <Text
            color="white"
            bold
            style={{ fontSize: 50, fontFamily: 'Poppins' }}
          >
            How it Works
          </Text>
        </HeadingWrapper>
        <GraphicWrapper>
          <Graphic name="OnboardingTribes" width={width * 0.32} />
        </GraphicWrapper>
        <TextHeaderWrapper>
          <Text center bold style={{ fontFamily: 'poppins', fontSize: 24 }}>
            Use your traits to join tribes and anonymously interact with people
            like you
          </Text>
        </TextHeaderWrapper>
        <TextWrapper>
          <Text center style={{ fontFamily: 'rubik' }}>
            While every tribe is different, they let you interact with other
            data verified members with comments, polls, competitions, and more!
          </Text>
        </TextWrapper>
        <ButtonWrapper>
          <Spacing direction="row">
            <Button
              outline
              block
              style={{ width: '220px' }}
              onClick={() => history.push('./three')}
            >
              Previous
            </Button>
            <Button
              outline
              block
              style={{ width: '220px' }}
              onClick={() => history.push('./five')}
            >
              Next
            </Button>
          </Spacing>
        </ButtonWrapper>
      </div>
    )
  }
}
